// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 策略模拟信息 GET /qt-adviser/strategy-mock/info */
export async function qtAdviserStrategyMockInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserStrategyMockInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultRaStrategyMockInfoResp>('/qt-adviser/strategy-mock/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略模拟-获取持仓 GET /qt-adviser/strategy-mock/position-list */
export async function qtAdviserStrategyMockPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserStrategyMockPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListQtStrategyMockPositionResp>(
    '/qt-adviser/strategy-mock/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 策略模拟-收益列表 GET /qt-adviser/strategy-mock/profit-list */
export async function qtAdviserStrategyMockProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserStrategyMockProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListQtStrategyMockProfitResp>(
    '/qt-adviser/strategy-mock/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 创建波段交易回测 POST /qt-adviser/swing-trade/backtest/create */
export async function qtAdviserSwingTradeBacktestCreateUsingPOST(
  body: API.SwingTradeBacktestCreateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultlong>('/qt-adviser/swing-trade/backtest/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除波段交易回测 POST /qt-adviser/swing-trade/backtest/delete */
export async function qtAdviserSwingTradeBacktestDeleteUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestDeleteUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/qt-adviser/swing-trade/backtest/delete', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 波段交易回测委托列表 GET /qt-adviser/swing-trade/backtest/entrust-list */
export async function qtAdviserSwingTradeBacktestEntrustListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestEntrustListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeBacktestEntrustResp>(
    '/qt-adviser/swing-trade/backtest/entrust-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测详情 GET /qt-adviser/swing-trade/backtest/info */
export async function qtAdviserSwingTradeBacktestInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeBacktestInfoResp>(
    '/qt-adviser/swing-trade/backtest/info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取用户波段交易回测列表 GET /qt-adviser/swing-trade/backtest/list */
export async function qtAdviserSwingTradeBacktestListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeBacktestResp>(
    '/qt-adviser/swing-trade/backtest/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测持仓列表 GET /qt-adviser/swing-trade/backtest/position-list */
export async function qtAdviserSwingTradeBacktestPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeBacktestPositionResp>(
    '/qt-adviser/swing-trade/backtest/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测收益列表 GET /qt-adviser/swing-trade/backtest/profit-list */
export async function qtAdviserSwingTradeBacktestProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListSwingTradeBacktestProfitResp>(
    '/qt-adviser/swing-trade/backtest/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易回测收益统计 GET /qt-adviser/swing-trade/backtest/profit-statistics */
export async function qtAdviserSwingTradeBacktestProfitStatisticsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeBacktestProfitStatisticsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeBacktestProfitStatisticsResp>(
    '/qt-adviser/swing-trade/backtest/profit-statistics',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段交易指标条件组列表 GET /qt-adviser/swing-trade/condition-group/list */
export async function qtAdviserSwingTradeConditionGroupListUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultListSwingTradeConditionGroupDetailResp>(
    '/qt-adviser/swing-trade/condition-group/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 波段交易模拟交易委托列表 GET /qt-adviser/swing-trade/mock/entrust-list */
export async function qtAdviserSwingTradeMockEntrustListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockEntrustListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeMockEntrustResp>(
    '/qt-adviser/swing-trade/mock/entrust-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 波段交易模拟交易详情 GET /qt-adviser/swing-trade/mock/info */
export async function qtAdviserSwingTradeMockInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeMockInfoResp>('/qt-adviser/swing-trade/mock/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 波段交易模拟交易持仓列表 GET /qt-adviser/swing-trade/mock/position-list */
export async function qtAdviserSwingTradeMockPositionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockPositionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeMockPositionResp>(
    '/qt-adviser/swing-trade/mock/position-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 波段交易模拟交易收益列表 GET /qt-adviser/swing-trade/mock/profit-list */
export async function qtAdviserSwingTradeMockProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListSwingTradeMockProfitResp>(
    '/qt-adviser/swing-trade/mock/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取波段模拟交易收益统计 GET /qt-adviser/swing-trade/mock/profit-statistics */
export async function qtAdviserSwingTradeMockProfitStatisticsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockProfitStatisticsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSwingTradeMockProfitStatisticsResp>(
    '/qt-adviser/swing-trade/mock/profit-statistics',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 波段交易模拟交易除权除息记录查询 GET /qt-adviser/swing-trade/mock/xrd-record/list */
export async function qtAdviserSwingTradeMockXrdRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeMockXrdRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSwingTradeMockXrdRecordResp>(
    '/qt-adviser/swing-trade/mock/xrd-record/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 创建波段交易策略 POST /qt-adviser/swing-trade/strategy/create */
export async function qtAdviserSwingTradeStrategyCreateUsingPOST(
  body: API.SwingTradeStrategyCreateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/qt-adviser/swing-trade/strategy/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除波段交易策略 POST /qt-adviser/swing-trade/strategy/delete */
export async function qtAdviserSwingTradeStrategyDeleteUsingPOST(
  body: API.SwingTradeStrategyDeleteReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/qt-adviser/swing-trade/strategy/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 波段交易策略列表 GET /qt-adviser/swing-trade/strategy/list */
export async function qtAdviserSwingTradeStrategyListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListSwingTradeStrategyInfoResp>(
    '/qt-adviser/swing-trade/strategy/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 波段交易策略-设置调仓通知订阅状态 POST /qt-adviser/swing-trade/strategy/notice-subscribe */
export async function qtAdviserSwingTradeStrategyNoticeSubscribeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qtAdviserSwingTradeStrategyNoticeSubscribeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/qt-adviser/swing-trade/strategy/notice-subscribe', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取交易条件模板列表 GET /qt-adviser/trade-rule-template/list */
export async function qtAdviserTradeRuleTemplateListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTradeRuleTemplateResp>('/qt-adviser/trade-rule-template/list', {
    method: 'GET',
    ...(options || {}),
  });
}
